import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import { initializeState, reportCleared } from "../../../store/sdlcReportSlice";
import { initFilter, initSort } from "../vulnerabilities/utils";
import { resetAllSlices, restoreState } from "./utils";
export const initialState = {
    filter: initFilter,
    sort: initSort,
    pagination: { itemsPerPage: 10, currentPage: 1 },
    filteredByLink: false,
};
const vulnerabilitiesSlice = createSlice({
    name: "fileBrowserVulnerabilities",
    initialState: initialState,
    reducers: {
        filterUpdated: (state, action) => {
            state.filter = cloneDeep(action.payload);
            state.filteredByLink = false;
            state.pagination.currentPage = 1;
        },
        filterByCve: (state, action) => {
            state.filter = cloneDeep(initFilter);
            state.filter.cve = action.payload;
            state.filter.hideTriaged = false;
            state.filteredByLink = true;
            state.pagination.currentPage = 1;
        },
        filterByExploitTag: (state, action) => {
            state.filter = cloneDeep(initFilter);
            state.filter.exploit = [action.payload];
            state.filteredByLink = true;
            state.pagination.currentPage = 1;
        },
        filterBySeverity: (state, action) => {
            state.filter = cloneDeep(initialState.filter);
            state.filter.cvss_score_severity = action.payload;
            state.filteredByLink = true;
            state.filter.hideTriaged = false;
            state.pagination.currentPage = 1;
        },
        sortUpdated: (state, action) => {
            state.sort = action.payload;
            state.pagination.currentPage = 1;
        },
        paginationUpdated: (state, action) => {
            state.pagination = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(initializeState, (state, action) => {
            return restoreState(state, action.payload, "vulnerabilities");
        });
        builder.addCase(reportCleared, () => {
            return cloneDeep(initialState);
        });
        builder.addCase(resetAllSlices, () => {
            return cloneDeep(initialState);
        });
    },
});
export const vulnerabilitiesReducer = vulnerabilitiesSlice.reducer;
export const { filterUpdated, filterByCve, filterByExploitTag, filterBySeverity, sortUpdated, paginationUpdated, } = vulnerabilitiesSlice.actions;
export const selectFilter = (state) => state.report.fileBrowser.vulnerabilities.filter;
export const selectSort = (state) => state.report.fileBrowser.vulnerabilities.sort;
export const selectPagination = (state) => state.report.fileBrowser.vulnerabilities.pagination;
export const selectFilteredByLink = (state) => state.report.fileBrowser.vulnerabilities.filteredByLink;
//# sourceMappingURL=vulnerabilitiesSlice.js.map